interface Props {
  email: string
}

export default function UnauthorizedPage({ email }: Props) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: 24 }}>
      <div className="card" style={{ maxWidth: 520, textAlign: 'center', padding: 48 }}>
        <h1 style={{ marginBottom: 20 }}>Kein Zugriff</h1>
        <p style={{ marginBottom: 12 }}>
          Der Benutzer <strong>{email}</strong> ist nicht eingerichtet.
        </p>
        <p style={{ color: 'var(--color-muted)' }}>
          Bitte bitten Sie einen Administrator, diesen Account anzulegen und eine Rolle zuzuweisen.
        </p>
      </div>
    </div>
  )
}
